import { LegacyIconBase, type LegacyIconProps } from './icons/LegacyIconBase';

export function FarcasterLegacyIcon(props: LegacyIconProps) {
  return (
    <LegacyIconBase color="#855DCD" {...props}>
      <g transform="translate(32 32) scale(2.25) translate(-12 -12.1)">
        <path d="M19.0555 17.4062v.504c.2868-.0256.5458.1905.5439.479v.5688h-5.1437v-.5688c-.0019-.2885.2576-.5047.5443-.479v-.504c0-.22.1525-.402.358-.458l-.0095-4.3645c-.1589-1.7366-1.6402-3.0979-3.4435-3.0979-1.8038 0-3.2846 1.3613-3.4435 3.0979l-.0096 4.3578c.2276.0424.5318.2083.5395.4648v.504c.2863-.0256.5457.1905.5438.479v.5688H4.3915v-.5688c-.0019-.2885.2575-.5047.5438-.479v-.504c0-.2529.2011-.4548.4536-.4724v-7.895h-.4905L4.2898 7.008l2.6405-.0005V5.0419h9.9495v1.9656h2.8219l-.6091 2.0314h-.4901v7.8949c.2519.0177.453.2195.453.4724" />
      </g>
    </LegacyIconBase>
  );
}
